module.exports = "pegasus_template/assets/blocks/column-4-theme4.png";